export default function ConfigPortfolioMock() {
  return (
    <div className="platform-mock mock-sidebar">
      <div className="platform-mock-header"><span className="dot" /> Portfolio</div>
      <div className="platform-mock-body">
        <div className="mock-sidebar-section">
          <div className="mock-sidebar-row">
            <span className="mock-sidebar-label">Capital</span>
            <span className="mock-sidebar-val" style={{ fontWeight: 700 }}>10000 <span style={{ color: '#6b7280', marginLeft: 4, fontSize: '0.625rem', fontWeight: 400 }}>USDT</span></span>
          </div>
          <div className="mock-sidebar-row">
            <span className="mock-sidebar-label">Direction</span>
            <span className="mock-sidebar-val" style={{ fontWeight: 700 }}>Long-only <span className="mock-sidebar-link">Change</span></span>
          </div>
          <div className="mock-sidebar-row" style={{ borderBottom: 'none', paddingTop: 0 }}>
            <span className="mock-sidebar-label" />
            <span style={{ fontSize: '0.5625rem', color: '#4b5563', fontStyle: 'italic' }}>Buy low, sell high only</span>
          </div>
          <div className="mock-sidebar-row">
            <span className="mock-sidebar-label">Objective</span>
            <span className="mock-sidebar-val" style={{ fontWeight: 700 }}>Sharpe Ratio <span className="mock-sidebar-link">Change</span></span>
          </div>
        </div>
      </div>
      <div className="platform-mock-caption">Set starting capital, trading direction, and the metric to optimise for.</div>
    </div>
  );
}
